var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.164 15.84a1.046 1.046 0 0 0 1.427 0l8.351-7.946a.57.57 0 0 0 0-.83l-.555-.528a.643.643 0 0 0-.87-.002l-7.638 7.27-7.64-7.27a.64.64 0 0 0-.87.002l-.555.528a.57.57 0 0 0 0 .83z"
})));
export default SvgIconClose;